import { useEffect, useState } from "react";

type Filters = {
  businessUnitId: string | null;
  endDate: string | null;
  startDate: string | null;
  propertyId: string | null;
  usagesType: string | null;
};

const STORAGE_KEY = "dashboardFilters";

export function useDashboardFilters() {
  const [filters, setFilters] = useState<Filters>(() => {
    try {
      // const stored = localStorage.getItem(STORAGE_KEY);
      // WIP
      const stored = null;
      return stored
        ? JSON.parse(stored)
        : {
            businessUnitId: null,
            endDate: null,
            startDate: null,
            propertyId: null,
            usagesType: null,
          };
    } catch {
      return {
        businessUnitId: null,
        endDate: null,
        startDate: null,
        propertyId: null,
        usagesType: null,
      };
    }
  });

  const updateFilters = (newFilters: Partial<Filters>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  // keep filters synced with localStorage but WIP
  // useEffect(() => {
  //   localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  // }, [filters]);

  return { filters, updateFilters };
}
